import { useTheme, useMediaQuery } from '@mui/material';
import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  Button,
  TextField,
  Box,
  Typography,
  FormControl,
  Select,
  FormHelperText,
  Grid,
} from "@mui/material";
import dayjs from "dayjs";
import {
  alphanumericWithSpaceValidation,
  validateEmail,
  validateField,
} from "../../common/helpers/validation";
import {
  AntiTheft,
  CommonYesNo,
  Usage,
  primaryoperator,
  ownershipType
} from "../../common/StaticFieldList";
import {
  createVehicleInfo,
  getAllVehicleInfo,
  updateVehicleInfo,
} from "../../redux/actions/vehicleInfoActions";
import { populateValue } from "../../common/helpers/utils";
import DatePickerField from "../general/DatePickerField";

const requiredFields = ["usage"];

const validationRulesQuote = [
  { fieldName: "usage", label: "Usage",
    type: "select", option: Usage,
    id: "usage",
   },
   {
    fieldName: "rideShare",
    label: "Ride Share",
    type: "select",
    option: CommonYesNo,
    id: "rideshare",

  },
  {
    fieldName: "primaryOperator",
    label: "Primary Operator",
    type: "select",
    option: primaryoperator,
    id: "primaryoperator",
  },
  {
    fieldName: "milesDrivenToWork",
    label: "Miles Driven to Work",
    type: "number",
    id: "milesdrivenwork",
  },
  {
    fieldName: "annualMilesDriven",
    label: "Annual Miles Driven",
    type: "number",
    id: "annualmilesdriven",
  },
  { fieldName: "purchaseDate",
    label: "Purchase Date", type: "date",
    id: "purchasedDates",
   },
  {
    fieldName: "salvaged",
    label: "Salvaged/Rebuilt",
    type: "select",
    option: CommonYesNo,
    id: "salvaged",
  },
  {
    fieldName: "leasedVehicle",
    label: "Ownership Type",
    type: "select",
    option: ownershipType,
    id: "leasedVehicle",
  },
  {
    fieldName: "antiTheft",
    label: "Anti Theft",
    type: "select",
    option: AntiTheft,
    id: "antitheft",
  },
  { fieldName: "modified",
    label: "Modified",
    type: "number",
    //  option: modified,
    id: "modified",
   },
];

const validationFunctions = {
  firstName: alphanumericWithSpaceValidation,
  lastName: alphanumericWithSpaceValidation,
  email: validateEmail,
};

const VehicleAttribute = forwardRef(({
  setShowHideVehicleForm,
  vehicleData,
  backData,
  handleNext,
  handleSubmitVehicleAttr,
  handleSubmitVehicleNextInfo,
  handleBackward,
  vehicleInfoData,
}, ref) => {
  const [isDirty, setIsDirty] = useState(false);
  const dispatch = useDispatch();
  const getGpId = useSelector((state) => state.generalPartyInfo.gpId)
    let quoteId = getGpId;
  const theme = useTheme();
  // const VehicleInfo = useSelector((state) => state.vehicleInfo.savedVehicleInfo);
const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
// const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const newFieldArg = [...validationRulesQuote];

  const [formState, setFormState] = useState({
    formData: newFieldArg.reduce(
      (fields, { fieldName }) => ({
        ...fields,
        [fieldName]: "",
      }),
      {}
    ),
    touchedFields: newFieldArg.reduce(
      (fields, { fieldName }) => ({
        ...fields,
        [fieldName]: false,
      }),
      {}
    ),
    fieldErrors: newFieldArg.reduce(
      (errors, { fieldName }) => ({
        ...errors,
        [fieldName]: "",
      }),
      {}
    ),
  });
  const dynamicTheme = useSelector((state) => state?.theme?.theme[0]);

  const { formData, touchedFields, fieldErrors } = formState;
  const isFormValid = () => {
  const allRequiredFieldsFilled = requiredFields.every((fieldName) => {
    const value = formData[fieldName];
    return value && value.toString().trim() !== "";
  });
  const noValidationErrors = requiredFields.every((fieldName) => !fieldErrors[fieldName]);
  return allRequiredFieldsFilled && noValidationErrors;
};
  const handleInputChange = (e) => {
    setIsDirty(true);
    const { name, value } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      formData: {
        ...prevState.formData,
        [name]: value,
      },
    }));
  };

   const handleBackSubmit = () => {

      handleBackward(vehicleInfoData)
    };
  const handleDateChange = (date, fieldName) => {
    const formattedDate = date ? dayjs(date).format("MM-DD-YYYY") : "";
    setIsDirty(true);
    const customEvent = {
      preventDefault: () => {},
      target: {
        name: fieldName,
        value: formattedDate,
      },
    };

    handleInputChange(customEvent);
  };

  const handleBlur = (field) => {
    setFormState((prevFormState) => ({
      ...prevFormState,
      touchedFields: {
        ...prevFormState.touchedFields,
        [field]: true,
      },
    }));

    if (!requiredFields.includes(field)) {
      return;
    }

    const value = formData[field];
    const error = validateField(
      value,
      newFieldArg.find((rule) => rule.fieldName === field).label
    );

    const additionalError = validationFunctions[field]
      ? validationFunctions[field](value)
      : "";

    setFormState((prevFormState) => ({
      ...prevFormState,
      fieldErrors: {
        ...prevFormState.fieldErrors,
        [field]: error || additionalError,
      },
    }));
  };

  const handleSnackbarOpen = (message, severity) => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };
 const handleFormSubmit = async(event) => {
    event.preventDefault();
    // if (VehicleInfo?.id) {
    //     // Spread VehicleInfo FIRST, then formData to override null values
    //     const combinedFormData = {
    //         ...VehicleInfo,      // Spread VehicleInfo first
    //         ...formData,         // Then spread formData (overrides null values)
    //         id: VehicleInfo.id,  // Ensure id is preserved
    //     }
    //     await dispatch(
    //         updateVehicleInfo(combinedFormData, () => {})
    //     );
    //     // handleSubmitVehicleNextInfo(combinedFormData)

    // }
     handleSubmitVehicleAttr(formData);
    setIsDirty(false);
};

  useImperativeHandle(ref, () => ({
   shouldConfirm: () => false,
   saveWithoutNav: async () => ({ ok: true }),
   resetForm: () => {
     setFormState((prev) => ({
       ...prev,
       formData: Object.fromEntries(Object.keys(prev.formData).map((k) => [k, ""])),
       touchedFields: Object.fromEntries(Object.keys(prev.touchedFields).map((k) => [k, false])),
       fieldErrors: Object.fromEntries(Object.keys(prev.fieldErrors).map((k) => [k, ""])),
     }));
     setIsDirty(false);
   },
 }));


  const getDefaultFieldValue = (fieldName, vehicleData, fieldArgs) => {
    if (fieldName === 'purchaseDate') {
      const rawDOB = vehicleData?.[fieldName];

      if (!rawDOB) {
        return '';
      }

      const parsedDate = dayjs(rawDOB, ["MM-DD-YYYY", "YYYY-MM-DD", "DD-MM-YYYY"], true);
      if (!parsedDate.isValid()) {
        return '';
      }

      const formattedDate = parsedDate.format('MM-DD-YYYY');
      return formattedDate;
    }

    return (vehicleData && populateValue(vehicleData[fieldName], fieldName, fieldArgs)) || '';
  };

  useEffect(() => {
    if(vehicleData?.id)
    {
    const updatedFormData = newFieldArg.reduce(
      (fields, { fieldName }) => ({
        ...fields,
        [fieldName]: getDefaultFieldValue(fieldName, vehicleData, newFieldArg),
      }),
      {}
    );

    setFormState((prevFormState) => ({
      ...prevFormState,
      formData: updatedFormData,
    }));
  }
  else
  {
    const updatedFormData = newFieldArg.reduce(
      (fields, { fieldName }) => ({
        ...fields,
        [fieldName]: getDefaultFieldValue(fieldName, backData, newFieldArg),
      }),
      {}
    );

    setFormState((prevFormState) => ({
      ...prevFormState,
      formData: updatedFormData,
    }));
  }
  }, [vehicleData,backData]);
  return (
    <Box sx={{ width: '100%', maxWidth: '100%', overflowX: 'hidden',
         '@media (min-width: 768px) and (max-width: 1024px)': {
            minHeight: '90vh',
            height: 'auto',
            overflowY: 'auto',
          },
          '@media (min-width: 1024px) and (min-height: 1366px)': {
            height: 'auto',
            minHeight: '100vh',
          },
 }}>
      <Box sx={{
        alignSelf: "stretch",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "36px",
        maxWidth: "100%",
        padding: isMobile ? '0 10px' : '0',
      }}>
        <Box
          id="form"
          component="form"
          onSubmit={handleFormSubmit}
          sx={{
            width: isMobile ? '100%' : isTablet ? '90%' : '853px',
            borderRadius: "4px",
            backgroundColor: "#fff",
            border: "1px solid #e3e3e3",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            padding: "30px 0px 24px",
            gap: "23px",
            maxWidth: "100%",
          }}
        >
          <Typography
           id="vehicleattributes"
            variant="h1"
            component="div"
            sx={{
              border: "none",
              backgroundColor: "transparent",
              alignSelf: "stretch",
              height: "51px",
              fontFamily: '"Poppins", sans-serif',
              fontWeight: "600",
              fontSize: isMobile ? "20px" : "25px",
              color: dynamicTheme?.secondaryColor,
              paddingLeft: isMobile ? '20px' : "50px",
              display: "flex",
              alignItems: "center",
            }}
          >
            Vehicle Attributes
          </Typography>
          <hr style={{ borderTop: "1px solid #ccc", width: "100%" }} />
          <Box sx={{
            alignSelf: "stretch",
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-start",
            justifyContent: "flex-end",
            padding: isMobile ? '0 20px' : "0px 44px 0px 55px",
            boxSizing: "border-box",
            maxWidth: "100%",
            fontFamily: '"Poppins", sans-serif',
          }}>
            <Box sx={{
              flex: "1",
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              alignItems: "flex-start",
              justifyContent: "flex-start",
              gap: "16px",
              fontFamily: '"Poppins", sans-serif',
              maxWidth: "100%",
            }}>
              <Grid container spacing={2}>
                {validationRulesQuote.map(({ fieldName, label, type, option }, index) => (
                  <Grid item xs={12} sm={6} key={index}>
                    <Box sx={{
                      width: "100%",
                      margin: "0 0 15px 0",
                      display: "flex",
                      flexFlow: "column",
                    }}>
                      <Typography
                       key={fieldName}
                        variant="body1"
                        sx={{
                          position: "relative",
                          fontFamily: '"Poppins", sans-serif',
                          lineHeight: "40px",
                          fontWeight: "500",
                          display: "inline-block",
                          minWidth: "83px",
                          zIndex: "1",
                        }}
                      >
                        {label}
                        {requiredFields.includes(fieldName) && (
                            <span style={{ color: "red", marginLeft: "2px" }}>
                              *
                            </span>
                          )}
                      </Typography>
                      {fieldName === "purchaseDate" ? (
                        <DatePickerField
                          fieldName={fieldName}
                          formData={formData}
                          handleDateChange={handleDateChange}
                          handleBlur={handleBlur}
                          touchedFields={touchedFields}
                          fieldErrors={fieldErrors}
                        />
                      ) : type === "select" ? (
                        <FormControl
                          fullWidth
                          variant="outlined"
                          sx={{
                            border: "none",
                            backgroundColor: "transparent",
                            alignSelf: "stretch",
                            fontFamily: '"Poppins", sans-serif',
                            fontWeight: "500",
                            fontSize: "16px",
                            zIndex: "1",
                          }}
                        >
                          <Select
                            native
                            name={fieldName}
                            value={formData[fieldName] || ""}
                            onChange={(e) => handleInputChange(e)}
                            error={touchedFields[fieldName] && !!fieldErrors[fieldName]}
                            displayEmpty
                            required={requiredFields.includes(fieldName)}
                            id={fieldName}
                            inputProps={{ 'aria-label': label }}
                            sx={{
                              height: "55px",
                              "& .MuiInputBase-root": {
                                height: "55px",
                                backgroundColor: "#fff",
                                fontSize: "14px",
                                fontFamily: '"Poppins", sans-serif',
                              },
                              "& .MuiInputBase-input": {
                                color: dynamicTheme?.secondaryColor,
                                fontFamily: '"Poppins", sans-serif',
                              },
                              "& fieldset": {
                                borderColor: touchedFields[fieldName] && !!fieldErrors[fieldName]
                                  ? "#d32f2f"
                                  : "#C1C1C1",
                                fontFamily: '"Poppins", sans-serif',
                              },
                            }}
                          >
                            <option value="" disabled>
                              Select {label}
                            </option>
                            {option && option.map((opt) => (
                              <option key={opt.value} value={opt.value}>
                                {opt.label}
                              </option>
                            ))}
                          </Select>
                          {touchedFields[fieldName] && fieldErrors[fieldName] && (
                            <FormHelperText error>
                              {fieldErrors[fieldName]}
                            </FormHelperText>
                          )}
                        </FormControl>
                      ) : (
                        <TextField
                          fullWidth
                          type={type}
                          variant="outlined"
                          required={requiredFields.includes(fieldName)}
                          id={fieldName}
                          placeholder={label}
                          name={fieldName}
                          autoComplete={fieldName}
                          value={formData[fieldName]}
                          // onChange={(e) => {
                          //   if (type === "number" && e.target.value.length > 6) {
                          //     return;
                          //   }
                          //   handleInputChange(e);
                          // }}
                          onChange={(e) => {
                            let val = e.target.value;

                            // Allow only digits, no negative sign, no decimal
                            if (type === "number") {
                              if (val === "" || /^[0-9]+$/.test(val)) {
                                if (val.length <= 6) { // limit to 6 digits
                                  handleInputChange(e);
                                }
                              }
                            } else {
                              handleInputChange(e);
                            }
                          }}

                          error={
                            touchedFields[fieldName] &&
                            !!fieldErrors[fieldName]
                          }
                          helperText={
                            touchedFields[fieldName]
                              ? fieldErrors[fieldName]
                              : ""
                          }
                          sx={{
                            "& fieldset": {
                              borderColor: "#C1C1C1",
                              fontFamily: '"Poppins", sans-serif',
                            },
                            "& .MuiInputBase-root": {
                              height: "55px",
                              backgroundColor: "#fff",
                              fontSize: "16px",
                              fontFamily: '"Poppins", sans-serif',
                            },
                            "& .MuiInputBase-input": {
                              color: dynamicTheme?.secondaryColor,
                              fontFamily: '"Poppins", sans-serif',
                            },
                          }}
                        />
                      )}
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Box>

          <Box sx={{
                  width: "222px",
                  height: "42px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  gap: "14px",
                  fontFamily: '"Poppins", sans-serif',
                  padding: isMobile ? '0 20px' : '0',
          }}>
            <Button
             id="backbutton"
              startIcon={<ArrowBackIosIcon />}
              disableElevation={true}
              variant="outlined"
              onClick={handleBackSubmit}
            >
              Back
            </Button>

            <Button
             id="nextbutton"
              type="submit"
               disabled={!isFormValid()}
              endIcon={<ArrowForwardIosIcon />}
              disableElevation={true}
              variant="outlined"
              sx={{
                 background: !isFormValid()
                  ? "rgba(128, 128, 128, 0.6)" // Gray background when disabled
                  : theme.palette.primary.main,
                
                "&:disabled": {
                  color: "#fff",
                  opacity: 0.6,
                },
              }}
            >
              Next
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
});

export default VehicleAttribute;